import { Component, Output, EventEmitter, Injectable, Input, ElementRef, OnInit,
  AfterViewInit, Renderer2, OnChanges, ViewEncapsulation, Inject } from '@angular/core';

@Component({
  selector: 'abs-pagination',
  template: `
<div>
    <div class="pagi-skip-btn" tabindex="-1" role="navigation" [attr.aria-label]="'Customer Data Pages'">
        <div class="pagination-holder clearfix">
            <div class="pagination" [ngClass]="{'abs-go-to-page-inline' : inputClass !== undefined}">    
                <ul *ngIf="!isTouch && totalPages >= 1">    
                    <li *ngIf="totalPages > 10"><a abs-accessibility-click="13,32" [attr.aria-label]="currentPage  <= 1 ? 'Previous Page Disabled': 'Previous Page'" tabindex="{{currentPage  <= 1 ? '-1': '0'}}"  role="link" href="javascript:void(0)" class="prev abs-pager__item" (click)="prev($event)" [ngClass]="currentPage <= 1 ? 'disabled': '' "><i class="icon-left"></i></a></li>          
                    <li *ngIf="totalPages > 10 && currentPage > 6"><a abs-accessibility-click="13,32" [attr.aria-label]="'Page 1'+(checkSelectedPage(page) ? ' selected' : '')"  tabindex="0" href="javascript:void(0)" [attr.aria-selected]="checkSelectedPage(page)" class="abs-pager__item" title="Page 1{{checkSelectedPage(page) ? ' selected' : ''}}"  (click)="selectPage(1) ">1</a></li>        
                    <li *ngIf="totalPages > 10 && currentPage > 6"><a abs-accessibility-click="13,32" [attr.aria-label]="'Page 2'+(checkSelectedPage(page) ? ' selected' : '')"  tabindex="0" href="javascript:void(0)" [attr.aria-selected]="checkSelectedPage(page)" class="abs-pager__item" title="Page 2{{checkSelectedPage(page) ? ' selected' : ''}}"  (click)="selectPage(2) ">2</a></li>    
                    <li class="disabled " *ngIf="totalPages > 10 && currentPage > 6">
                        <span class="ellipse">...<span class="hidden-spoken"  tabindex="-1">more pages</span></span>
                    </li>
                    <li *ngFor="let page of pages">       
                        <a abs-accessibility-click="13,32" tabindex="0" href="javascript:void(0)" class="abs-pager__item" [ngClass]="{'abs-pager__item--active': checkSelectedPage(page)}" [attr.aria-label]="(checkSelectedPage(page) ? ' Active ' : '')+'Page '+page"  title="Page {{page}}{{checkSelectedPage(page) ? ' selected' : ''}}"  (click)="!checkSelectedPage(page) && selectPage(page, $event)">{{page}}</a>        
                    </li>           
                    <li class="disabled " *ngIf="totalPages > 10 && currentPage <= totalPages - 5">
                        <span class="ellipse">...<span class="hidden-spoken"  tabindex="-1">more pages</span></span></li>       
                    <li *ngIf="totalPages > 10 && currentPage <= totalPages - 5"><a abs-accessibility-click="13,32" tabindex="0" href="javascript:void(0)" [attr.aria-label]="'Page' +(checkSelectedPage(page) ? ' selected' : '')" class="abs-pager__item" [attr.aria-selected]="checkSelectedPage(page)"  title="Page {{totalPages - 1}}{{checkSelectedPage(page) ? ' selected' : ''}}"  (click)="selectPage(totalPages-1)">{{totalPages - 1}}</a></li>        
                    <li *ngIf="totalPages > 10 && currentPage <= totalPages - 5"><a abs-accessibility-click="13,32" tabindex="0" href="javascript:void(0)" [attr.aria-label]="'Page'+ (checkSelectedPage(page) ? ' selected' : '')" class="abs-pager__item" [attr.aria-selected]="checkSelectedPage(page)" title="Page {{totalPages}}{{checkSelectedPage(page) ? ' selected' : ''}}"  (click)="selectPage(totalPages)">{{totalPages}}</a></li>
                    <li *ngIf="totalPages > 10"><a abs-accessibility-click="13,32" [attr.aria-label]="currentPage >= totalPages? 'Next Page Disabled': 'Next Page'" tabindex="{{currentPage >= totalPages? '-1': '0'}}"  role="link" class="abs-pager__item" href="javascript:void(0)" [attr.aria-hidden]="false"  class="next" (click)="next($event)" [ngClass]="currentPage >= totalPages ? 'disabled' :'' "><i class="icon-right"></i></a>
                    </li>  
                </ul>
                <div class="input abs-go-to-page" *ngIf="totalPages > 20">
                    <label class="fieldLabel abs-go-to-label" for="goto">Go to page:</label>
                    <input type="text" class="abs-pager__item--input" role="textbox" id="goto" maxlength="4" [(ngModel)]="gotoPage" (ngModelChange)="onChange()" (keydown)="gotoKeyClick($event)" (focus)="onfocusIn($event)" (blur)="onfocusOut($event)" [attr.aria-label]="'enter user input page number then tab to submit'" app-ddh-only-digits>
                           <button disabled="" type="button" class="btn-arrow goToButton" (click)="gotoBtnClick()" [attr.aria-label]="'Submit'">
                        <span class="btn btn-small btn-secondary">
                            <i class="icon-right"></i>
                        </span>
                    </button>
                </div>
                <ul *ngIf="isTouch && totalPages >= 1" [ngClass]="isTouch ? 'mobile-view': '' ">
                    <li *ngFor="let page of pages">
                        <a tabindex="0" class="abs-pager__item" [ngClass]="{'abs-pager__item--active': checkSelectedPage(page)}" href="javascript:void(0)" [attr.aria-label]="checkSelectedPage(page) ? ' selected' : ''+'Page'+ page" [attr.aria-checked]="checkSelectedPage(page)" ddh-element-focus="isFocused(page)" ddh-accessibility-click="13,32" (click)="!checkSelectedPage(page) && selectPage(page)">{{page}}</a>
                    </li>
                </ul>

            </div>
        </div>
        <a href="javascript:void(0)" class="btn-skip pagi-hidden-spoken visible-phone" tabindex="{{isTouch && totalPages > 10 ? '0' : '-1'}}" [attr.aria-hidden]="isTouch && totalPages > 10 ? 'false' : 'true'" [attr.aria-label]="'Skip paginations links - backward'" ></a>
        <span [attr.id]="'firstskiphide'+id" class="visible-phone empty" tabindex="-1" [attr.aria-hidden]="false">&nbsp;</span>
    </div>
</div>`,
  styles: [`.pagination ul{list-style-type:none}.pagination ul li{display:inline}a.disabled>[class^=icon-]{color:#ccc;cursor:not-allowed}.abs-pager__item{border-radius:0;cursor:pointer;display:inline-block;margin:0 3px;height:23px;vertical-align:baseline}.fieldLabel{color:#666}.abs-go-to-page{margin-top:14px}.abs-pager__item--active{border-bottom:2px solid #0574ac;border-radius:0;color:#333}.abs-go-to-label{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.goToButton{padding-top:10px}.abs-pager__item--input{max-height:32px;max-width:50px;padding-left:0;padding-right:0;text-align:center;margin-left:5px}.btn-circular{font-weight:400;background-color:transparent;border:none;padding:5px 0 0;top:0;left:10px;color:#333;position:relative}.btn-circular[disabled] .btn{background-image:none;background-color:#767676;-webkit-box-shadow:none;box-shadow:none;cursor:not-allowed;color:#fff;border-color:transparent;outline:0!important}.btn-circular[disabled] .icon-right{color:#fff!important}.btn-circular .btn{border:1px solid transparent;border-radius:100%;height:36px;margin-bottom:0;margin-right:7px;max-width:36px;min-width:20px;padding:0;margin-top:-4px;vertical-align:middle;width:36px}.btn-circular .btn.btn-small{height:20px;max-width:20px;min-width:20px;width:20px;top:-1px}.btn-circular .btn.btn-small [class*=icon-]:before{font-size:10px;height:20px;line-height:25px;width:20px}.abs-go-to-page-inline{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.abs-go-to-page-inline .abs-go-to-page{margin-top:-3px}a:focus{text-decoration:none;outline:#191919 dotted thin}@media (max-width:1024px){.pagination .input,.pagination label{display:none!important}.pagination{overflow-y:hidden;overflow-x:scroll;-webkit-overflow-scrolling:touch;height:61px}.pagination-holder{height:44px;overflow:hidden}.pagination ul{white-space:nowrap;display:inline-block}.leftblur:before{content:"";display:inline-block;position:absolute;height:100%;left:-1px;z-index:1;width:1px;-webkit-box-shadow:-25px 3px 47px 50px #fff;box-shadow:-25px 3px 47px 50px #fff}.rightblur:after{content:"";display:inline-block;position:absolute;height:100%;right:-1px;z-index:1;width:1px;-webkit-box-shadow:23px 3px 37px 65px #fff;box-shadow:23px 3px 37px 65px #fff}}`],
})
export class AbsPaginationComponent implements OnChanges, OnInit, AfterViewInit {
  //  Input variables declared to fetch data from the demo-component
  @Input() public totalPages: any;
  @Input() public currentPage: any;
  @Input() public inputClass: any;
  @Output() public clickHandler: EventEmitter<any> = new EventEmitter();
  //  Output variables declared to reflect the changes in the values given in the input of demo
  //  EventEmitter is used to render the latest data that gets updated in DOM
  @Output() public currentPageChange: EventEmitter<any> = new EventEmitter();
  //  variables declared that will be used in the component functionality to handle various changes
  public focusedPage: any;    //  gets the active page
  public pages: any = [];     //  values in this array are pushed when user enters the total no. of pages
  public isTouch: any;       //   to check for the display object
  public firstPlay = true;    //  a boolean to check whether the data is changed after initial loading
  public qResult: any;        //  initialized to fetch the button in the DOM
  public pElement: any;       //  initialized to fetch the div element with class pagination
  public id: any = Math.random(); //  unique id generated for each list element
  public gotoPage: any;           //  contains value that is entered by user in goto button
  public focusElem: any;
  public boundary: any;
  constructor(
    @Inject(ElementRef) private el: ElementRef, 
    @Inject(Renderer2) private renderer: Renderer2) { }

  //  called initially at component loading or whenever one or more data-bound input properties change.
  ngOnChanges() {

      if (window.innerWidth < 1025) {
          this.isTouch = true;
      } else {
          this.isTouch = false;
      }

      this.renderer.listen(window, 'resize', () => {
          this.checkMobile();
          this.currentPageChanged(this.currentPage);
      });
      //  initially the current page is fetched according to value given by user during first time loading
      if (!this.firstPlay) {
          if (this.currentPage === undefined || this.currentPage === 1 || this.currentPage === null || this.currentPage === '') {
              this.currentPageChanged(1);
          } else {
              this.currentPageChanged(this.currentPage);
          }
          this.onscroll(this.pElement);
      } else {
          this.firstPlay = false;
          this.selectPage(this.currentPage);
      }

  }
  //  Initializes the component
  ngOnInit() {
      this.pElement = this.el.nativeElement.querySelector('.pagination');
      //        this.focusElem = this.el.nativeElement.querySelectorAll('ul');

  }
  //  Responds after Angular2 initializes the component's views and child views
  ngAfterViewInit() {
      this.onscroll(this.pElement);
      this.renderer.listen(this.pElement, 'scroll', (event) => {
          this.onscroll(this.pElement);
      });
  }
  //  fetches the full tableData, calculates the start and end index based on goto page value given by user and extracts the data
  public callBackHandler(num) {
      this.clickHandler.emit(num);
  }
  //  loads the page links in <li> when totalPages value is passed, also checks for current page
  public currentPageChanged(value) {
      if (value !== undefined && value !== null) {
          if (!value || value < 1) {
              value = 1;
              this.currentPage = 1;
          }
          if (value > this.totalPages) {
              value = this.totalPages;
          }
          if (this.currentPage !== value) {
              this.currentPage = value;
              this.selectPage(value);
          }
          if (value === null) {
              this.currentPage = 1;
          }
          this.pages = [];
          if (!this.isTouch) {
              if (this.totalPages <= 10) {
                  for (let i = 1; i <= this.totalPages; i++) {
                      this.pages.push(i);
                  }
              }
              if (this.totalPages > 10) {
                  const val = parseInt(value, 10);
                  this.boundary = this.getBoundary(val);
                  if (val <= 6) {
                      this.pages = [1, 2, 3, 4, 5, 6, 7];
                  } else if ( val <= (this.totalPages - this.boundary) ) { // Middle section
                        if ( 7 <= val && val < 9 ) {
                            if(this.totalPages < 100) {
                                this.pages = [val - 3, val - 2, val - 1, val, val + 1, val + 2];
                            } else if(this.totalPages < 1000) {
                                this.pages = [val - 2, val - 1, val, val + 1, val + 2];
                            } else if(this.totalPages < 10000) {
                                this.pages = [val - 2, val - 1, val, val + 1, val + 2];
                            }
                        } else if ( 9 <= val && val < 100 ) {
                            this.pages = [val - 3, val - 2, val - 1, val, val + 1, val + 2];
                        } else if ( 100 <= val && val < 1000 ) {
                            this.pages = [val - 2, val - 1, val, val + 1];
                        } else if ( 1000 <= val ) {
                            this.pages = [val - 1, val, val + 1];
                        }
                    } else if ( (this.totalPages - this.boundary) < val ) { // Right (last) section
                        if ( val < 100 ) {
                            this.pages = [this.totalPages - 5, this.totalPages - 4, this.totalPages - 3, this.totalPages - 2, this.totalPages - 1, this.totalPages];
                        } else if ( 100 <= val && val < 1000 ) {
                            this.pages = [this.totalPages - 4, this.totalPages - 3, this.totalPages - 2, this.totalPages - 1, this.totalPages];
                        } else if ( 1000 <= val ) {
                            this.pages = [this.totalPages - 3, this.totalPages - 2, this.totalPages - 1, this.totalPages];
                        }
                    }
              }
          }
          let w: any; let el: any; let l: any; let ew: any;
          if (this.isTouch) {
              for (let i = 1; i <= this.totalPages; i++) {
                  this.pages.push(i);
              }
              //  calculates the space in mobile view and adds or removes blur class accordingly
              setTimeout(() => {
                  w = this.pElement.getBoundingClientRect().width;
                  l = this.pElement.scrollLeft;
                  const listElem = this.el.nativeElement.querySelector('li');
                  const activeElem = this.el.nativeElement.querySelector('li.active');
                  if ((activeElem !== null && activeElem !== undefined) && (listElem !== null && listElem !== undefined)) {
                      ew = listElem.getBoundingClientRect().width;
                      el = activeElem.offsetLeft;
                      this.tween(l, el - (w / 2) + (ew * 0.15), 500);
                      if ((l + w < this.el.nativeElement.querySelector('ul').offsetWidth - (ew / 2))) {
                          this.el.nativeElement.querySelector('.pagination-holder').classList.add('rightblur');
                      } else if (!(l + w < this.el.nativeElement.querySelector('ul').offsetWidth - (ew / 2))) {
                          this.el.nativeElement.querySelector('.pagination-holder').classList.remove('rightblur');
                      }
                  }
              }, 200);
          }
      }
      this.focusedPage = value;
  }

  //caliculates the boundary based on the totalpages input
  public getBoundary(value:number) {
    if ( value < 100 ) {
        return 5;
    } else if ( 100 <= value && value < 1000 ) {
        return 4;
    } else if ( 1000 <= value ) {
        return 3;
    } else {
        return 5; // error
    }
  };
  
  //  adds or removes blur class on scrolling through the list of pages in mobile view
  public onscroll(element) {

      let w: any; let l: any; let elemWidth: any; let lastScroll: any; let totwidth: any;
      w = element.getBoundingClientRect().width;
      l = element.scrollLeft;
      const activeElem = this.el.nativeElement.querySelector('li.active');
      const lastElem = this.el.nativeElement.querySelector('li:last-child');
      if ((activeElem !== null && activeElem !== undefined) && (lastElem !== null && lastElem !== undefined)) {
          elemWidth = activeElem.getBoundingClientRect().width / 2;
          lastScroll = lastElem.offsetLeft;
          totwidth = w + elemWidth;
          if (totwidth > lastScroll - l) {
              this.el.nativeElement.querySelector('.pagination-holder').classList.remove('rightblur');
          }
          if (totwidth < lastScroll - l) {
              this.el.nativeElement.querySelector('.pagination-holder').classList.add('rightblur');
          }
          if (l > elemWidth) {
              this.el.nativeElement.querySelector('.pagination-holder').classList.add('leftblur');
          } else {
              this.el.nativeElement.querySelector('.pagination-holder').classList.remove('leftblur');
          }
      }
  }
  //  moves the links in a loop in mobile view
  public tween(start, end, duration) {
      const instance = this;
      const delta = end - start;
      let startTime;
      if (window.performance && window.performance.now) {
          startTime = performance.now();
      } else if (Date.now) {
          startTime = Date.now();
      } else {
          startTime = new Date().getTime();
      }
      const tweenLoop = function (time) {
          const t = (!time ? 0 : time - startTime);
          const factor = instance.easing(t, 0, 1, duration);
          instance.pElement.scrollLeft = start + delta * factor;
          if (t < duration && instance.pElement.scrollLeft !== end) {
              requestAnimationFrame(tweenLoop);
          }
      }
      tweenLoop(null);
  }
  public easing(t, b, c, d) {
      return c * (t /= d) * t + b;
  }
  //  fetches and reflects the new value of current page to set it as active link
  public selectPage(value) {

      this.currentPage = value;
      this.currentPageChange.emit(this.currentPage);
      this.focusedPage = value;
      if (value === undefined || value === null || value === '') {
          value = 1;
      }
      this.currentPageChanged(value);
      this.el.nativeElement.querySelector('.pagination-holder').focus();
      this.callBackHandler(this.currentPage);

  }
  //  checks if the selected page is currentPage or not
  public checkSelectedPage(value) {
      if (this.currentPage === value) {
          return true;
      }
      return false;
  }
  //  implemented on next icon button to move to next link if the icon is pressed, called on click of next icon in html
  public next(event) {
      if (event !== undefined) {
          event.preventDefault();
          //event.currentTarget.blur();
      }
      if (this.currentPage < this.totalPages) {
          this.currentPage += 1;
          this.selectPage(this.currentPage);
          this.isFocused(this.currentPage);
          this.callBackHandler(this.currentPage);
      }
  }
  //  implemented on previous icon button to move to next link if the icon is pressed, called on click of previous icon in html
  public prev(event) {
      if (event !== undefined) {
          event.preventDefault();
          //event.currentTarget.blur();
      }
      if (this.currentPage > 1) {
          this.currentPage -= 1;
          this.selectPage(this.currentPage);
          this.isFocused(this.currentPage);
          this.callBackHandler(this.currentPage);
      }
  }

  //called on click of go to page input focus
  public onfocusIn(evt) { 
    var qResult = this.el.nativeElement.querySelector('.goToButton').classList.remove('go-to-disabled');
  }

  //called on removal of focus from goto page input box
  public onfocusOut(evt) {
    var qResult = this.el.nativeElement.querySelector('.goToButton').classList.add('go-to-disabled');
  }

  //  called when enter key is pressed after giving the goto page value
  public gotoKeyClick(keyEvent) {
      if (keyEvent.which === 13 && this.gotoPage) {
          this.gotoBtnClick();
      }
  }
  //  goto page value is fetched, set and button icon is disabled, and customHandler is called
  public gotoBtnClick() {
      this.currentPageChanged(parseInt(this.gotoPage, 10));
      this.callBackHandler(this.currentPage);
      this.qResult = this.el.nativeElement.querySelector('.goToButton');
      this.qResult.setAttribute('disabled', true);
      this.removeClass(this.qResult, 'active');
      setTimeout(() => {
          this.el.nativeElement.querySelector('.goToButton').focus();
      }, 50);
      this.gotoPage = null;
  }
  //  sets the button icon active if some value is input by user in goto
  public onChange() {
      if (this.gotoPage) {
          this.qResult = this.el.nativeElement.querySelector('.goToButton');
          this.qResult.removeAttribute('disabled');
          this.addClass(this.qResult, 'active');
      } else {
          this.qResult = this.el.nativeElement.querySelector('.goToButton');
          this.qResult.setAttribute('disabled', 'true');
          this.removeClass(this.qResult, 'active');
      }
  }
  public checkMobile() {
      if (window.innerWidth < 1025) {
          this.isTouch = true;
      } else {
          this.isTouch = false;
      }
  }
  //  retreives the active page
  public isFocused(page) {
      return this.focusedPage === page;
  }
  //  generic functions to add, remove a class or set the css on element
  public addClass(element, className) {
      this.renderer.addClass(element, className);
  }
  public removeClass(element, className) {
      this.renderer.removeClass(element, className);
  }
  public fixUpCSS(element, cssObject) {
      for (let key = 0; key < Object.keys(cssObject).length; key++) {
          element.style[Object.keys(cssObject)[key]] = cssObject[Object.keys(cssObject)[key]];
      };
  }

}
